export default {"src":"/_next/static/media/map.7aadbdf8.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};